<template>
    <div>
        <stats-card title="System status" type="success" sub-title="Grid health" icon="fas fa-medkit">

            <template slot="actions">
                <a class="dropdown-item" href="#">Export to CSV</a>
                <a class="dropdown-item" href="#">Refresh</a>
            </template>

            <template slot="append">

                <b-card no-bod class="tab-wrapper">

                    <b-card-header header-tag="nav">
                        <b-nav card-header tabs>
                            <b-nav-item @click="setActiveIssue('overview')" :active="activeTab == 'overview'">Overview</b-nav-item>
                            <b-nav-item v-for="(value, name) in healthIssueTypes" :key="name" @click="setActiveIssue(name)" :active="activeTab == name">{{value}} <span :class="`ml-1 badge badge-${getColorByIssueTally(name)}`">{{getIssueTypeTally(name)}}</span></b-nav-item>
                        </b-nav>
                    </b-card-header>

                    <div class="tab-container" v-if="activeTab == 'overview'">
                        <base-alert type="warning">
                            There are currently <strong>N</strong> issues requiring your attention throughout the RapidAIM grid.<br>
                            Click on any tab to browse details
                        </base-alert>
                    </div>

                    <div class="tab-container" v-if="activeTab != 'overview'">
                        <el-table
                            class="table-responsive table-flush"
                            header-row-class-name="thead-light"
                            row-key="id"
                            :data="sortedHealthIssues[activeTab]"
                            >
                            
                            <el-table-column label="Barcode" prop="barcode" sortable>
                                <template v-slot="{ row }">
                                    <strong>{{ row.barcode }}</strong>
                                </template>
                            </el-table-column>
                            
                            <el-table-column min-width="120px" label="" align="center" class="pr-0">
                                <template v-slot="{ row }">
                                    <div class="d-flex justify-content-end">
                                        <router-link :to="{ name: 'user', params: { id: row.id }}">
                                            <base-button size="sm" type="dark">View</base-button>
                                        </router-link>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                </b-card>

            </template>

        </stats-card>

    </div>
</template>

<script>

import api from '@/api'
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip } from 'element-ui';

export default {
  name: 'grid-health',
  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
        healthData: [],
        healthIssueTypes: {
            "lowBattery": "Battery",
            "badGPS": "Location",
            "poorCommunication": "Communication",
            "notActive": "Inactive"
        }, 
        loading: true,
        activeTab: "overview",
        sortedHealthIssues: {}
    };
  },
  created: async function() {
    this.$emit('loading', true);
    const results = await api.getGridHealth()
    this.$emit('loading', false);
    this.healthData = results;
    this.sortHealthIssues()
  },
  methods: {
    setActiveIssue: function(name) {
        this.activeTab = name;
    },
    sortHealthIssues: function() {
        for(let index in this.healthData) {
            let issue = this.healthData[index];
            if(this.sortedHealthIssues[issue.issue] == undefined) this.sortedHealthIssues[issue.issue] = []
            this.sortedHealthIssues[issue.issue].push(issue)
        }
    },
    getIssueTypeTally: function(name) {
        return this.sortedHealthIssues[name] != undefined ? this.sortedHealthIssues[name].length : (Math.floor(Math.random() * Math.floor(20))) // TODO remove random generated tally
    },
    getColorByIssueTally: function(category) {
        let tally = this.sortedHealthIssues[category] != undefined ? this.sortedHealthIssues[category].length : 0;
        if(tally >= 10) return 'danger';
        if(tally >= 5) return 'warning';
        if(tally >= 1) return 'warning';
        return 'warning' // TODO change back to success
    }
  }
};
</script>
